import React from 'react';
import { Section, SectionHeading } from '../ui/Section';
import { Reveal } from '../ui/Reveal';
import { CtaButton } from '../ui/CtaButton';
import { PaymentNote } from '../ui/PaymentNote';
export function FinalCta() {
  return <Section className="bg-[linear-gradient(180deg,#f8f9fa_0%,#f0f4e8_100%)]" aria-labelledby="decision-titulo" data-id="element-95" data-mp="1no6q8pb750y2">
      <Reveal data-id="element-96" data-mp="1sm87d4p2aq6w">
        <SectionHeading id="decision-titulo" align="center" data-id="element-97" data-mp="1slzsj79dpat2">
          Toma tu decisión hoy
        </SectionHeading>
      </Reveal>

      <div className="mx-auto mt-9 grid max-w-4xl gap-4 md:grid-cols-2 md:gap-5" data-id="element-98" data-mp="1iqeluvtd7mcz">
        <Reveal data-id="element-99" data-mp="14q3vdtvyw9sc">
          <article className="flex h-full flex-col border-l-4 border-alert bg-white p-6 sm:p-7" data-id="element-100" data-mp="14qncj8dsmu5b">
            <h3 className="text-xs font-semibold uppercase tracking-[0.14em] text-alert-deep sm:text-sm" data-id="element-101" data-mp="19ooufpzhgnf7">
              Opción A
            </h3>
            <p className="mt-3 text-[0.95rem] leading-relaxed text-body sm:text-base" data-id="element-102" data-mp="2z4oe410q9v93">
              Seguir como estás: la misma tarde de las 4, el mismo antojo, la misma culpa a las 10
              de la noche. Y en seis meses, la misma conversación contigo misma.
            </p>
          </article>
        </Reveal>

        <Reveal delay={0.07} data-id="element-103" data-mp="3tdbmkui6v773">
          <article className="flex h-full flex-col border-l-4 border-forest bg-white p-6 sm:p-7" data-id="element-104" data-mp="b1ye24cezh6k">
            <h3 className="text-xs font-semibold uppercase tracking-[0.14em] text-forest sm:text-sm" data-id="element-105" data-mp="6zbibscmhc43">
              Opción B
            </h3>
            <p className="mt-3 text-[0.95rem] leading-relaxed text-body sm:text-base" data-id="element-106" data-mp="3fg6ll8xc0yip">
              Aplicar el código en tu próxima comida. Misma comida, orden distinto. Y una tarde con
              energía estable hoy mismo, sin contar nada.
            </p>
          </article>
        </Reveal>
      </div>

      <Reveal delay={0.14} data-id="element-107" data-mp="3jfx7ozbwyqgw">
        <div className="mt-9 flex justify-center" data-id="element-108" data-mp="13q40cvj49e8i">
          <CtaButton href="#comprar" size="lg" data-id="element-109" data-mp="13osu8p277ue8">
            Sí, Quiero El Protocolo Completo
          </CtaButton>
        </div>
        <PaymentNote className="mx-auto mt-5 max-w-md" data-id="element-110" data-mp="yt3scf2pi1er" />
      </Reveal>
    </Section>;
}